export enum Language {
  DE_LANG_KEY = 'de',
  EN_LANG_KEY = 'en',
}
